var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9344 3.43662C29.7637 2.77115 29.4288 2.16428 28.9634 1.67675C28.4981 1.18922 27.9185 0.83812 27.2826 0.658599C24.9422 1.33636e-07 15.5605 0 15.5605 0C15.5605 0 6.17885 -1.33636e-07 3.83845 0.655095C3.20236 0.834035 2.62246 1.18494 2.15699 1.67256C1.69153 2.16018 1.35688 2.76736 1.18666 3.43312C0.560547 5.88535 0.560547 11 0.560547 11C0.560547 11 0.560547 16.1147 1.18666 18.5634C1.53153 19.9156 2.54939 20.9806 3.83845 21.3414C6.17885 22 15.5605 22 15.5605 22C15.5605 22 24.9422 22 27.2826 21.3414C28.5751 20.9806 29.5896 19.9156 29.9344 18.5634C30.5605 16.1147 30.5605 11 30.5605 11C30.5605 11 30.5605 5.88535 29.9344 3.43662ZM12.5806 15.6943V6.30573L20.3485 10.965L12.5806 15.6943Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.10673159a9ef31d0d4281930d8ce76c7.svg";
export { ForwardRef as ReactComponent };